export const EMAIL_SAC_BRIO = 'mailto:sac@brioincorporadora.com.br'
export const FORM_ASSISTANCE_TECHNICAL = 'https://www.mobuss.com.br/presol/htdocs/programs/brio/presol-brio.jsf'
